<template>
  <div class="cards pt-6 gap-7">
    <ArticleCard
      v-for="post in posts"
      :key="post.id"
      :post="post"
      :has-excerpt="hasExcerpt"
    />
  </div>
</template>

<script setup lang="ts">
import type { BlogPost } from '~/types';

const COLUMN_COUNT = 2;

defineProps<{
  posts: BlogPost[];
  hasExcerpt?: boolean;
  columns?: number;
}>();
</script>

<style scoped>
.cards {
  display: grid;
  grid-template-columns: repeat(v-bind('columns || COLUMN_COUNT'), 1fr);
}
@media (max-width: 850px) {
  .cards {
    grid-template-columns: 1fr;
    margin-top: var(--space-6);
    gap: var(--space-8);
  }
}
</style>